import React, { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import HtmlParser from "html-react-parser";
import { RootState } from "us.helper/types";
import { useTranslation } from "react-i18next";
import { isArray } from "lodash";
import { getPageProperties } from "functions/EditorHome";
import { DocumentType } from "constants/TemplateEditor";

type LivePreviewProps = {
  pageIndex?: number;
};

const LivePreview: React.FC<PropsFromRedux & LivePreviewProps> = (props) => {
  const { pageIndex = 0, templatePreview, template } = props;
  const { t } = useTranslation();

  const htmlContent = useMemo(() => {
    if (isArray(templatePreview.data) && templatePreview.data.length > 0) {
      return templatePreview.data[pageIndex];
    }
    return "<></>";
  }, [pageIndex, templatePreview.data]);

  const pageProperties = useMemo(() => {
    return getPageProperties(template.data?.outPutFormat as DocumentType);
  }, [template.data?.outPutFormat]);

  return (
    <div
      className="d-flex flex-column align-items-center template-preview preview-page"
      style={{
        height: pageProperties.height,
        width: pageProperties.width,
        overflowY: "auto",
      }}
    >
      {template.loading ||
        (templatePreview.isLoading && (
          <span className="page-loading">{t("COMMON.LOADING")}...</span>
        ))}
      {isArray(templatePreview.data) && <>{HtmlParser(htmlContent)}</>}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templateEditor, templatesHistory } = state;
  const { section, parameters, adapters, previewData, templatePreview } =
    templateEditor;
  const { template } = templatesHistory;

  return {
    section,
    parameters,
    template,
    adapters,
    previewData,
    templatePreview,
  };
};

const connector = connect(mapStateToProps, {});

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(LivePreview);
